import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз 2ТЭМ109 002';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Типа 2ТЭМ109 №002</p>
                    <p>Построен в 1969 году на Луганском тепловозостроительном заводе</p>
                    <p>Конструктивная скорость - 140 км/ч</p>
                    <p>Масса - 120т</p>
                    <p>Мощность - 3000 л.с.</p>
                    <p>При замене колесных пар может эксплуатироваться на колее 1435 мм.</p>
                    <p>В 1969 году выпущено 3 2ТЭ109</p>
                    <p>Двухсекционный вариант ТЭ109. Для серийного выпуска, по-видимому, никогда не предназначался, был спроектирован специально для сравнительных испытаний с 2ТЭ40 и 2ТЭ10Л.</p>
                    <ul>
                        <li>год выпуска 1969</li>
                        <li>построено 3</li>
                        <li>изготовитель - Луганский завод</li>
                        <li>дизели: 2Д70, 1А-5Д49 (2 х 3000 л.с.)</li>
                        <li>вес 240 т</li>
                        <li>нагрузка на ось 20 т</li>
                        <li>скорость 100 км/ч</li>
                        <li>мощность 4620 л.с.</li>
                    </ul>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt062.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt063.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt064.jpg')} /></div>
            </div>
        </>
    );
}